export default (locale) => {
  return `https://help.reverb.com/hc/${locale}`;
};



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/components/shared/user_help_center_url.js